import React, { useState, useEffect } from 'react';
import { useMiniERPEDI } from './hooks/useMiniERPEDI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faStar, faLightbulb } from '@fortawesome/free-solid-svg-icons';

const MiniERPTrasRecoveryRoi = ({ caseId }) => {
  const { fetchTrasRecoveryRoi } = useMiniERPEDI();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!caseId) return;
    fetchTrasRecoveryRoi(caseId).then((res) => setData(res?.data));
  }, [caseId]);

  if (!data) return <div className="p-4 text-gray-500">Loading...</div>;

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold text-cyan-200 mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faChartPie} /> Recovery ROI
      </h2>

      <div className="bg-gray-800 rounded-2xl p-6 mb-4 text-center">
        {data.roi !== null ? (
          <>
            <div className="text-5xl font-bold text-emerald-400">{data.roi}×</div>
            <div className="text-gray-500 text-sm mt-1">Recovery ROI</div>
          </>
        ) : (
          <>
            <div className="text-2xl font-semibold text-gray-400">Not yet scored</div>
            <div className="text-gray-500 text-xs mt-1">ROI formula hasn't been configured yet — this is a real placeholder, not a fake number.</div>
          </>
        )}
        <div className="grid grid-cols-2 gap-3 mt-5 text-sm">
          <div className="bg-gray-900 rounded-xl p-3">
            <div className="text-emerald-400 font-bold text-lg">₹{data.recoveredAmount}</div>
            <div className="text-gray-500 text-xs">Recovered</div>
          </div>
          <div className="bg-gray-900 rounded-xl p-3">
            <div className="text-rose-400 font-bold text-lg">₹{data.totalCost}</div>
            <div className="text-gray-500 text-xs">Cost of Collection</div>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 rounded-2xl p-5 mb-4">
        <h3 className="text-sm font-semibold text-gray-300 mb-2 flex items-center gap-2">
          <FontAwesomeIcon icon={faStar} /> Customer Collection Score
        </h3>
        {data.collectionScore !== null ? (
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <FontAwesomeIcon key={i} icon={faStar} className={i <= data.collectionScore ? 'text-amber-400' : 'text-gray-600'} />
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-xs">Scoring formula hasn't been configured yet.</p>
        )}
      </div>

      <div className="bg-violet-950/30 border border-violet-700 rounded-2xl p-5">
        <h3 className="text-sm font-semibold text-violet-300 mb-2 flex items-center gap-2">
          <FontAwesomeIcon icon={faLightbulb} /> Think5Whys AI Recommends
        </h3>
        <p className="text-gray-400 text-xs">
          AI insights aren't wired to a live model yet for this case — this panel is a placeholder pending a decision on which provider/prompt to use here.
        </p>
      </div>
    </div>
  );
};

export default MiniERPTrasRecoveryRoi;
